















import { isTouchDevice } from '@/web/utils/detect-device';
import Vue, { PropOptions } from 'vue';
interface LocalProps {
  target: PropOptions;
  placement: PropOptions;
}

export default Vue.extend({
  name: 'HMInfoPopover',
  props: {
    target: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'righttop',
    },
    size: {
      type: String,
      default: null,
    },
    desktopTriggers: {
      type: String,
      default: 'hover focus',
    },
    mobileTriggers: {
      type: String,
      default: 'click blur',
    },
  } as LocalProps,
  data() {
    return {
      triggers: isTouchDevice() ? this.mobileTriggers : this.desktopTriggers,
    };
  },
});
